import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useProjectStore } from 'Store/Project'
import { shallow } from 'zustand/shallow'
import moment from 'moment'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

const ViewModel = () => {
  const { id } = useParams<{ page: string; id: string }>()
  const { selected, edit, getOne, openProject, closeProject } = useProjectStore(
    state => ({
      selected: state.selected,
      getOne: state.getOne,
      edit: state.edit,
      openProject: state.open,
      closeProject: state.close,
    }),
    shallow
  )
  const [hasEdit, setHasEdit] = useState(false)
  const [formState, setFormState] = useState({
    startJobDate: '',
    endJobDate: '',
    totalExpectPile: '0',
  })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const onChangeFormState = (key: string, value: any) => {
    setFormState({
      ...formState,
      [key]: value,
    })
    setHasEdit(true)
  }

  const handleData = () => {
    setFormState({
      // @ts-ignore
      startJobDate: selected?.startJobDate ? moment(selected?.startJobDate) : '',
      // @ts-ignore
      endJobDate: selected?.endJobDate ? moment(selected?.endJobDate) : '',
      totalExpectPile: selected?.totalExpectPile ? selected?.totalExpectPile.toString() : '0',
    })
  }

  const onSubmit = () => {
    if (hasEdit) {
      setIsSubmitting(true)
      edit(id ? parseInt(id) : 0, {
        startJobDate:
          moment(formState.startJobDate).isValid() && formState.startJobDate !== ''
            ? moment(formState.startJobDate).toISOString()
            : null,
        endJobDate:
          moment(formState.endJobDate).isValid() && formState.endJobDate !== ''
            ? moment(formState.endJobDate).toISOString()
            : null,
        totalExpectPile: parseInt(formState.totalExpectPile),
      }).then(({ success, data }) => {
        if (!success) {
          toast.error(data)
          setIsSubmitting(false)
        } else {
          toast.success('บันทึกข้อมูลสำเร็จ')
          getOne(id ? parseInt(id) : 0)
          setHasEdit(false)
          setIsSubmitting(false)
        }
      })
    }
  }
  const onOpenproject = () => {
    if (selected) {
      Swal.fire({
        title: 'ยืนยันการเปิดโครงการ',
        text: 'คุณต้องการเปิดโครงการนี้ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then(result => {
        if (result.isConfirmed) {
          openProject(selected.id).then(({ success, data }) => {
            if (!success) {
              toast.error(data)
            } else {
              toast.success('เปิดโครงการสำเร็จ')
              getOne(selected.id)
            }
          })
        }
      })
    }
  }
  const onCloseproject = () => {
    if (selected) {
      Swal.fire({
        title: 'ยืนยันการปิดโครงการ',
        text: 'คุณต้องการปิดโครงการนี้ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
      }).then(result => {
        if (result.isConfirmed) {
          closeProject(selected.id).then(({ success, data }) => {
            if (!success) {
              toast.error(data)
            } else {
              toast.success('ปิดโครงการสำเร็จ')
              getOne(selected.id)
            }
          })
        }
      })
    }
  }
  useEffect(() => {
    handleData()
    // eslint-disable-next-line
  }, [selected])

  return {
    isSubmitting,
    hasEdit,
    formState,
    projectState: selected.projectState,
    onChangeFormState,
    onSubmit,
    onOpenproject,
    onCloseproject,
  }
}

export default ViewModel
